module.exports = __webpack_public_path__ + "4d42d3034d0b06fb4c4cea0c3a014f20.pdf";